<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch3" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="VST"><span aria-label="4" id="pg_4" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch3" id="ch3" title="Link target outside of Sample"><b><i>There are moments in time</i></b></span></span></h1>
</header>
<blockquote>
<p class="V">that your mind will never allow you to forget.</p>
<p class="V">A fragrance, a nostalgic scent that you</p>
<p class="V">identify <i>with one person</i> aids in mental</p>
<p class="V">recall. <i>Autumn is a trigger for me.</i> I smell the</p>
<p class="V">heaviness of the ombre leaves as they begin</p>
<p class="V">their great descent, and the memories cascade</p>
<p class="V">like raindrops from heaven. <i>A kiss on the</i></p>
<p class="V"><i>bank of a swollen river whilst my toes sink</i></p>
<p class="V"><i>into sticky mud that feels like chocolate</i></p>
<p class="V"><i>frosting. Broad shoulders below me, bent</i></p>
<p class="V"><i>knees, trembling like the strings of a guitar—</i></p>
<p class="V"><i>asking if I will be his for a lifetime.</i> There</p>
<p class="V">was no exaggeration in his tone, and I wish I</p>
<p class="V">had known then that he meant every rehearsed</p>
<p class="V">syllable, while stroking my youthful soul with</p>
<p class="V">the words a naïve girl longs to hear. <i>Lifetime.</i></p>
<p class="V">Because even after all these years, there are</p>
<p class="V">days that I still feel like I belong to him—<i>and</i></p>
<p class="V"><i>he to me.</i> And I shake myself awake, and remind</p>
<p class="V">my lungs to breathe, because I’d rather die</p>
<p class="V">than be back there, in that lifetime, <i>willing</i></p>
<p class="VSB"><i>myself to believe in another day.</i></p>
<p class="V">The thing is, I spent most of our years</p>
<p class="V">together trying to find a way out. And no</p>
<p class="V">one knew.</p>
</blockquote>
<section epub:type="division">
<h2 class="H1"><b><i>It was him or me, and I decided—</i></b></h2>
</section>
<section epub:type="division">
<h2 class="H1"><b><i>I wanted to live.</i></b></h2>
</section>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?080c9566